export default __webpack_public_path__ + "static/media/Card Payment_Monochromatic.fc6b5d15.svg";